/** Shared nav row height — primary rail + configure panel (Figma NavItem) */
export const sidebarNavRowHeightClassName = 'h-[38px]';

/** Collapsed icon-rail — Figma Side Nav: 48×38, centered icon */
export const sidebarNavItemIconOnlyClassName =
  'w-[48px] shrink-0 justify-center !px-0 gap-0';

/**
 * Shared Figma sidebar nav row (node 2391:17522 / Left Nav 3042:34140)
 * Default: transparent · Active/hover: Grey/100 · dark: sidebar pill (Grey/100 @ 10%) · radius 6px · h 38
 */
export const sidebarNavItemClassName =
  'flex h-[38px] w-full cursor-pointer items-center gap-3 rounded-nav px-4 transition-colors hover:bg-grey-100 dark:hover:bg-sidebar-pill-dark disabled:cursor-not-allowed disabled:opacity-50 group-data-[collapsible=icon]:w-[48px] group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:!px-0 group-data-[collapsible=icon]:gap-0';

/** Panel beside the rail (chats, settings) — same width, surface and border so swapping panels does not shift. */
export const sidebarSidePanelClassName =
  'flex h-full w-[var(--sidebar-configure-width)] flex-col border-r border-grey-100 bg-true-white dark:border-sidebar-border dark:bg-sidebar';

export const sidebarNavItemActiveClassName = 'bg-grey-100 dark:bg-sidebar-pill-dark';

/**
 * Figma section/tree rows (9012:212896) — h 38, gap 8, radius 4, px 10.
 * Inset within the chats panel padding so hover/active do not hug the left edge.
 */
export const sidebarSectionItemRowClassName =
  'group relative flex h-[38px] w-full min-w-0 cursor-pointer items-center gap-2 overflow-hidden rounded px-2.5 text-left transition-colors hover:bg-grey-100 dark:hover:bg-sidebar-pill-dark';
